import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { Flex, Box, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { InfoPopover } from '@adsk/alloy-react-tooltip';

import i18n from '../../utils/i18n';

type ConfigurationItemProps = {
  collapsed?: boolean;
};

/**
 * Template Configuration side navigation item footer
 */
const TemplateConfigurationItemFooter: FC<ConfigurationItemProps> = (props) => (
  <>
    <Divider
      style={{
        width: 'auto',
        margin: '0 16px',
      }}
    />
    {!props.collapsed && (
      <Flex
        color="charcoal800"
        alignItems="center"
        fontWeight="bold"
        margin="16px 14px 12px"
        style={{
          textTransform: 'uppercase',
        }}
      >
        <Text fontWeight="bold" fontSize={14}>
          {i18n.t('TEMPLATE')}
        </Text>
        <InfoPopover
          message={
            <div style={{ whiteSpace: 'normal' }}>
              <Box mb={4}>
                <Text fontWeight="bold">{i18n.t('SET_UP_TEMPLATE')}</Text>
              </Box>
              {i18n.t('SET_UP_TEMPLATE_DESC')}
            </div>
          }
          placement={InfoPopover.PLACEMENTS.LEFT}
          size={14}
          style={{ lineHeight: 0, padding: '0 10px' }}
        />
      </Flex>
    )}
  </>
);

TemplateConfigurationItemFooter.propTypes = {
  collapsed: PropTypes.bool,
};

export default TemplateConfigurationItemFooter;
